import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import ConsultationModal from "./ConsultationModal";
import styles from "../styles/Footer1.module.css";

const Footer = () => {
  const [isConsultationOpen, setIsConsultationOpen] = useState(false);
  const consultationTriggerRef = useRef(null);
  const currentYear = new Date().getFullYear();

  const openConsultationModal = (event) => {
    consultationTriggerRef.current = event.currentTarget;
    setIsConsultationOpen(true);
  };

  const closeConsultationModal = () => {
    setIsConsultationOpen(false);
    window.setTimeout(() => {
      consultationTriggerRef.current?.focus();
    }, 0);
  };

  return (
    <>
    <footer className={styles.footerContainer}>
      <div className={styles.backgroundGlow}></div>

      <div className={styles.footerContent}>
        {/* Call To Action Banner */}
        <section className={styles.ctaCard}>
          <div className={styles.ctaGlow}></div>
          <div className={styles.globeDecoration}></div>

          <div className={styles.ctaText}>
            <h2>How Can We Help You?</h2>

            <p>
              Tell us about your software, automation, or digital transformation
              requirement. Our team is here to help.
            </p>
          </div>

          <div className={styles.ctaActions}>
            <button
              type="button"
              className={styles.primaryButton}
              onClick={openConsultationModal}
            >
              <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path
                  d="M7 3V6M17 3V6M4 9H20M5 5H19C19.5523 5 20 5.44772 20 6V19C20 19.5523 19.5523 20 19 20H5C4.44772 20 4 19.5523 4 19V6C4 5.44772 4.44772 5 5 5Z"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M8 13H10M14 13H16M8 16H10M14 16H16"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                />
              </svg>

              <span>Book a Free Consultation</span>
            </button>

            <Link to="/contact" className={styles.secondaryButton}>
              <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path
                  d="M4 6H20V18H4V6Z"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinejoin="round"
                />
                <path
                  d="M4 7L12 13L20 7"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>

              <span>Contact Us</span>
            </Link>
          </div>
        </section>

        <div className={styles.topDivider}></div>

        {/* Main Footer */}
        <div className={styles.footerMain}>
          {/* Company Information */}
          <div className={styles.companyColumn}>
            <Link to="/" className={styles.brand}>
              <div className={styles.brandIcon}>
                <img
                  src="/logo.png"
                  alt="VishvaConnect Technologies LLP"
                  className={styles.logoImage}
                  width="70"
                  height="60"
                />
              </div>

              <div className={styles.brandName}>
                <strong>VISHVACONNECT</strong>
                <span>Technologies LLP</span>
              </div>
            </Link>

            <p className={styles.companyDescription}>
              We build practical software, WhatsApp automation, dashboards, and
              digital systems for governments, enterprises, and growing
              organizations.
            </p>
          </div>

          {/* Quick Links */}
          <div className={styles.footerColumn}>
            <h3>Quick Links</h3>
            <div className={styles.headingLine}></div>

            <ul>
              <li>
                <Link to="/">
                  <span className={styles.arrow}>›</span>
                  Home
                </Link>
              </li>

              <li>
                <Link to="/about">
                  <span className={styles.arrow}>›</span>
                  About
                </Link>
              </li>

              <li>
                <Link to="/services">
                  <span className={styles.arrow}>›</span>
                  Services
                </Link>
              </li>

              <li>
                <Link to="/career">
                  <span className={styles.arrow}>›</span>
                  Career
                </Link>
              </li>

              <li>
                <Link to="/contact">
                  <span className={styles.arrow}>›</span>
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Solutions */}
          <div className={styles.footerColumn}>
            <h3>Solutions</h3>
            <div className={styles.headingLine}></div>

            <ul className={styles.solutionList}>
              <li>
                <Link to="/services">
                  <span className={styles.blueDot}></span>
                  Government Portal Development
                </Link>
              </li>

              <li>
                <Link to="/services">
                  <span className={styles.blueDot}></span>
                  WhatsApp Automation
                </Link>
              </li>

              <li>
                <Link to="/services">
                  <span className={styles.blueDot}></span>
                  MIS &amp; Dashboards
                </Link>
              </li>

              <li>
                <Link to="/services">
                  <span className={styles.blueDot}></span>
                  Workflow Automation
                </Link>
              </li>

              <li>
                <Link to="/services">
                  <span className={styles.blueDot}></span>
                  AI &amp; Intelligent Automation
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className={styles.footerColumn}>
            <h3>Contact</h3>
            <div className={styles.headingLine}></div>

            <div className={styles.contactList}>
              <a href="mailto:hello@vishvaconnect.com">
                <span className={styles.contactIcon}>
                  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path
                      d="M4 6H20V18H4V6Z"
                      stroke="currentColor"
                      strokeWidth="1.8"
                    />
                    <path
                      d="M4 7L12 13L20 7"
                      stroke="currentColor"
                      strokeWidth="1.8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>

                <span>hello@vishvaconnect.com</span>
              </a>

              <a
                href="https://www.vishvaconnect.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className={styles.contactIcon}>
                  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <circle
                      cx="12"
                      cy="12"
                      r="9"
                      stroke="currentColor"
                      strokeWidth="1.8"
                    />
                    <path
                      d="M3 12H21M12 3C14.5 5.5 15.5 8.5 15.5 12C15.5 15.5 14.5 18.5 12 21M12 3C9.5 5.5 8.5 8.5 8.5 12C8.5 15.5 9.5 18.5 12 21"
                      stroke="currentColor"
                      strokeWidth="1.5"
                    />
                  </svg>
                </span>

                <span>www.vishvaconnect.com</span>
              </a>

              <div className={styles.contactItem}>
                <span className={styles.contactIcon}>
                  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path
                      d="M20 10C20 15 12 21 12 21C12 21 4 15 4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10Z"
                      stroke="currentColor"
                      strokeWidth="1.8"
                      strokeLinejoin="round"
                    />
                    <circle
                      cx="12"
                      cy="10"
                      r="2.5"
                      stroke="currentColor"
                      strokeWidth="1.8"
                    />
                  </svg>
                </span>

                <span>Maharashtra, India</span>
              </div>
            </div>
          </div>

          {/* Social Media */}
          <div className={styles.footerColumn}>
            <h3>Follow Us</h3>
            <div className={styles.headingLine}></div>

            <div className={styles.socialLinks}>
              <a
                href="https://www.facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className={styles.facebook}
              >
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path
                    fill="currentColor"
                    d="M14 8H17V4.5C16.4 4.4 14.8 4.2 13 4.2C9.5 4.2 7.1 6.3 7.1 10.2V13H3V17H7.1V24H12.1V17H16.2L16.9 13H12.1V10.6C12.1 9.4 12.5 8 14 8Z"
                  />
                </svg>
              </a>

              <a
                href="https://www.instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className={styles.instagram}
              >
                <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <rect
                    x="3"
                    y="3"
                    width="18"
                    height="18"
                    rx="5"
                    stroke="currentColor"
                    strokeWidth="2"
                  />
                  <circle
                    cx="12"
                    cy="12"
                    r="4"
                    stroke="currentColor"
                    strokeWidth="2"
                  />
                  <circle cx="17.5" cy="6.5" r="1" fill="currentColor" />
                </svg>
              </a>

              <a
                href="https://www.linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className={styles.linkedin}
              >
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path
                    fill="currentColor"
                    d="M5.5 7.8C7 7.8 8 6.8 8 5.4C8 4 7 3 5.6 3C4.1 3 3.1 4 3.1 5.4C3.1 6.8 4.1 7.8 5.5 7.8ZM3.4 21H7.7V9.2H3.4V21ZM10 21H14.3V14.4C14.3 12.7 14.6 11 16.8 11C19 11 19 13 19 14.5V21H23.3V13.7C23.3 10.1 22.5 7.4 18.3 7.4C16.3 7.4 15 8.5 14.4 9.5H14.3V7.8H10V21Z"
                  />
                </svg>
              </a>

              <a
                href="https://www.youtube.com/@VishvaConnect"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube"
                className={styles.youtube}
              >
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path
                    fill="currentColor"
                    d="M23.2 7.2C23 5.8 22.1 4.8 20.7 4.5C18.7 4 12 4 12 4C12 4 5.3 4 3.3 4.5C1.9 4.8 1 5.8 0.8 7.2C0.5 9 0.5 12 0.5 12C0.5 12 0.5 15 0.8 16.8C1 18.2 1.9 19.2 3.3 19.5C5.3 20 12 20 12 20C12 20 18.7 20 20.7 19.5C22.1 19.2 23 18.2 23.2 16.8C23.5 15 23.5 12 23.5 12C23.5 12 23.5 9 23.2 7.2ZM9.5 15.5V8.5L15.8 12L9.5 15.5Z"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className={styles.bottomDivider}></div>

        <div className={styles.bottomBar}>
          <div className={styles.copyright}>
            <span className={styles.shieldIcon}>
              <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path
                  d="M12 2L20 5V11C20 16.2 16.6 20.3 12 22C7.4 20.3 4 16.2 4 11V5L12 2Z"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinejoin="round"
                />
                <path
                  d="M9 12L11 14L15.5 9.5"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>

            <span>
              © {currentYear} VishvaConnect Technologies LLP. All rights
              reserved.
            </span>
          </div>

          <div className={styles.legalLinks}>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <span className={styles.legalDivider}></span>
            <Link to="/terms-and-conditions">Terms &amp; Conditions</Link>
          </div>
        </div>
      </div>
    </footer>

    <ConsultationModal
      isOpen={isConsultationOpen}
      onClose={closeConsultationModal}
    />
    </>
  );
};

export default Footer;
